<script setup>
import { trackQuoteCtaClick } from '@/lib/analytics'

const props = defineProps({
  label: { type: String, default: 'Pedir cotización' },
  // De qué CTA salió el clic, para medir qué convierte igual que en WhatsApp.
  source: { type: String, default: '' },
  href: { type: String, default: '#cotizar' },
  // glow: ámbar sobre oscuro. ink: café sobre claro. outline: sin relleno.
  variant: { type: String, default: 'glow' },
  size: { type: String, default: 'base' },
  // En la navbar el botón se colapsa a solo-ícono (el sobre) hasta lg, donde se
  // expande a la pastilla con texto. Así la marca no compite con el CTA en móvil.
  collapse: { type: Boolean, default: false }
})

const variantClasses = {
  glow: 'bg-glow text-night hover:bg-[#f4a62a]',
  ink: 'bg-ink text-linen hover:bg-[#3a2b21]',
  outline: 'border border-current text-current hover:bg-current/10'
}

const sizeClasses = {
  base: 'px-6 py-3.5 text-sm',
  large: 'px-8 py-4.5 text-base',
  small: 'px-5 py-3 text-sm'
}
</script>

<template>
  <a
    :href="href"
    class="group inline-flex items-center rounded-full font-semibold tracking-wide transition-colors duration-300"
    :class="collapse
      ? [variantClasses[variant], 'h-11 w-11 justify-center gap-0 text-sm lg:h-auto lg:w-auto lg:gap-2.5 lg:px-5 lg:py-3']
      : [variantClasses[variant], 'gap-2.5', sizeClasses[size]]"
    :aria-label="collapse ? label : undefined"
    @click="trackQuoteCtaClick(source)"
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      class="shrink-0"
      :class="collapse ? 'h-5 w-5 lg:h-[1.15em] lg:w-[1.15em]' : 'h-[1.15em] w-[1.15em]'"
      aria-hidden="true"
    >
      <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="2" />
      <path d="m4 7.5 8 5 8-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <span :class="{ 'hidden lg:inline': collapse }">{{ label }}</span>
  </a>
</template>
